import ServerError from '@/common/utils/errors/ServerError';
import MassOperationError from '@/common/utils/errors/MassOperationError';
import ValidationError from '@/common/utils/errors/ValidationError';

type ErrorInfo = {
  message: string,
  details: string | string[] | object | undefined
}

export default class CriticalDataRetrieveError extends ServerError {
  errorMessage: string;
  errorDetails: any;

  constructor(err) {
    super(err.response, err.body, err.message, `Critical data retrieve error: ${err.name}`);
    this.errorMessage = this.formatError(err).message;
    this.errorDetails = this.formatError(err).details;
  }

  formatError(error: Error): ErrorInfo {
    switch (true) {
      case error instanceof MassOperationError:
        return {
          message: error.message,
          details: (error as MassOperationError).accumulatedErrors
        };
      case error instanceof ValidationError:
        return {
          message: error.message,
          details: (error as ValidationError).errorData
        };
      case error instanceof ServerError:
        return {
          message: error.message,
          details: (error as ServerError).fields
        };
      default:
        return {
          message: error.message,
          details: undefined
        };
    }
  }
}
